import request from '@/utils/request'
import qs from 'qs'

const proxyUrl = process.env.Communityapi;
const Jingjiribao = process.env.Jingjiribao;


// 优秀作品列表
export const outStandWork = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    // url: proxyUrl + '​/content​/outStandWork​/page',
    url: proxyUrl + '/content/outStandWork/page',
    data: qs.stringify(data),

  })
};



// 优秀作品列表  最热
export const outStandWorkList = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    // url: proxyUrl + '​/content​/outStandWork​/page',
    url: proxyUrl + '/content/outStandWorkList',
    data: qs.stringify(data),

  })
};

// 优秀作品详情
export const findByContentId = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    // url: proxyUrl + '​/content​/outStandWork​/page',
    url: proxyUrl + '/content/findByContentId',
    data: qs.stringify(data),
  })
};



// 优秀作品 评论
export const doComment_post = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    // url: proxyUrl + '​/content​/outStandWork​/page',
    url: Jingjiribao + '/content/doComment',
    data: qs.stringify(data),
  })
};

// 优秀作品 评论列表
export const doCommentList = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    // url: proxyUrl + '​/content​/outStandWork​/page',
    url: Jingjiribao + '/content/getCommentList',
    data: qs.stringify(data),
  })
};

// 优秀作品 点赞
export const doPraise = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    // url: proxyUrl + '​/content​/outStandWork​/page',
    url: Jingjiribao + '/content/addCollectPraise',
    data: qs.stringify(data),
  })
};
// /content/addCollectPraise

// 点赞数量
export const doPraiseExite = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    // url: proxyUrl + '​/content​/outStandWork​/page',
    url: Jingjiribao + '/content/getInfo',
    data: qs.stringify(data),
  })
};


// 浏览量
export const viewCount = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    url: Jingjiribao + '/work/viewCount',
    // url: Jingjiribao + '/content/addStatistics',
    data: qs.stringify(data),
  })
};



// 优秀作品 收藏
export const addCollect = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    // url: proxyUrl + '​/content​/outStandWork​/page',
    url: Jingjiribao + '/work/addCollect',
    data: qs.stringify(data),
  })
};



// 优秀作品 精彩推荐
export const getjctjPicList = (data) => {
  return request({
    //headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    // url: proxyUrl + '​/content​/outStandWork​/page',
    url: Jingjiribao + '/work/getjctjPicList',
    data: qs.stringify(data),
  })
};


// 优秀作品 下载
// export const downPic = (data) => {
//   return request({
//     //headers: {'Content-Type':'application/json','Accept': 'application/json'},
//     method: 'post',
//     // url: proxyUrl + '​/content​/outStandWork​/page',
//     url: Jingjiribao + '/trade/downPic?workId=' + data.workId,
//     data: qs.stringify(data),
//   })
// };




// WEBPACK FOOTER //
// ./src/utils/api/good_works.js